// extracted by mini-css-extract-plugin
export default {"iconSizeSmall":"1.28rem","iconSizeMedium":"1.57rem","iconSizeLarge":"1.71rem","iconSizeExtraLarge":"4.5rem","fontSizeBasePx":"14","container":"Icon_container__lWC2S"};